/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      // console.log('Container ———————— ↓');
      // console.log(container);
      // console.log('Variant —————————— ↓');
      // console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
  
  function setCollapsedStateForGrid(grid, collapsed) {
    if (!grid) return;
    var items = grid.querySelectorAll('.new-product-swatch');
    if (collapsed) {
      grid.classList.add('is-collapsed');
      if (items.length === 0) return;
      var firstRowTop = items[0].offsetTop;
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        if (item.offsetTop > firstRowTop) {
          item.classList.add('is-hidden-when-collapsed');
        } else {
          item.classList.remove('is-hidden-when-collapsed');
        }
      }
    } else {
      grid.classList.remove('is-collapsed');
      for (var j = 0; j < items.length; j++) {
        items[j].classList.remove('is-hidden-when-collapsed');
      }
    }
  }

  function recalcAllCollapsedGrids(scope) {
    var root = scope || document;
    var grids = root.querySelectorAll('[data-swatch-grid].is-collapsed');
    for (var i = 0; i < grids.length; i++) {
      setCollapsedStateForGrid(grids[i], true);
    }
  }

  // Initialize any grids that start collapsed
  document.addEventListener('DOMContentLoaded', function() {
    recalcAllCollapsedGrids(document);
    var readyGrids = document.querySelectorAll('[data-swatch-grid].is-collapsed');
    for (var i = 0; i < readyGrids.length; i++) {
      readyGrids[i].classList.add('is-ready');
    }
  });

  document.addEventListener('theme:resize:width', function() { recalcAllCollapsedGrids(document); });
  var lastResizeWidth = window.innerWidth;
  window.addEventListener('resize', function() {
    var w = window.innerWidth;
    if (w !== lastResizeWidth) {
      lastResizeWidth = w;
      recalcAllCollapsedGrids(document);
    }
  });

  document.addEventListener('click', function(e) {
    var toggle = e.target.closest('[data-show-all-swatches]');
    if (!toggle) return;

    // Scope to nearest swatch container; fallback to fieldset for backwards compatibility
    var container = toggle.closest('[data-swatch-container]') || toggle.closest('fieldset');
    var grids = container ? container.querySelectorAll('[data-swatch-grid]') : null;
    if (!grids || grids.length === 0) return;

    var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
    var nextExpanded = !isExpanded;

    toggle.setAttribute('aria-expanded', String(nextExpanded));
    for (var i = 0; i < grids.length; i++) {
      setCollapsedStateForGrid(grids[i], !nextExpanded);
    }

    var label = toggle.querySelector('p');
    if (label) {
      var moreText = toggle.dataset.textMore || 'Voir tous';
      var lessText = toggle.dataset.textLess || 'Voir moins';
      label.textContent = nextExpanded ? lessText : moreText;
    }
  });

  document.addEventListener('theme:variant:change', function(event) {
    console.log("🚀 ~ event:", event)
    var variant = event.detail.variant;
    var container = event.target;
    let customDiscountData = document.querySelector(`[data-custom-discount-data="${event.detail.variant.featured_image.product_id}"]`);
    customDiscountData = JSON.parse(customDiscountData.innerHTML);
    if (variant) {
      // Rebuild subscription plan selects to reflect allocations for this variant
      rebuildSubscriptionPlanSelectsForVariant(variant);

      const swatch = document.querySelector(`.new-product-swatch[data-variant-id="${variant.id}"]`);
      const price_element = document.querySelector('.product__subs__group .product__subs__price.one-time-purchase');

      if (swatch && price_element) {
        const variant_price = swatch.dataset.variantPrice;
        if (typeof customDiscountData !== 'undefined' && customDiscountData.show_discount) {
          return;
        } else {
          price_element.innerHTML = variant_price;
        }
      }

      // Also refresh subscription price displays based on current selected selling plan(s)
      var planSelects = document.querySelectorAll('.product__subs__plans select[name="selling_plan"]');
      for (var i = 0; i < planSelects.length; i++) {
        updateSubscriptionPriceFromSelect(planSelects[i]);
      }
    }
  });
  
  // Delegated listener to update subscription price when plan selection changes
  document.addEventListener('change', function(e) {
    var select = e.target.closest('.product__subs__plans select[name="selling_plan"]');
    if (!select) return;
    updateSubscriptionPriceFromSelect(select);
  });

  // When toggling group radios, ensure the price for the selected subscription group is up to date
  document.addEventListener('change', function(e) {
    var radio = e.target.closest('.product__subs__group [data-toggles-group]');
    if (!radio) return;
    // Only apply for subscription groups (ignore one-time purchase radio which has empty value)
    if (!radio.value) return;
    var group = radio.closest('.product__subs__group');
    if (!group) return;
    var select = group.querySelector('.product__subs__plans select[name="selling_plan"]');
    if (select) updateSubscriptionPriceFromSelect(select);
    
    // Hide economy badges for non-selected groups
    document.querySelectorAll('.product__subs__group').forEach(function(g) {
      var badge = g.querySelector('[data-economy-badge]');
      if (badge && g !== group) {
        badge.style.display = 'none';
      }
    });
  });

  // Initialize subscription price text from currently selected plan on load
  document.addEventListener('DOMContentLoaded', function() {
    var planSelects = document.querySelectorAll('.product__subs__plans select[name="selling_plan"]');
    for (var i = 0; i < planSelects.length; i++) {
      updateSubscriptionPriceFromSelect(planSelects[i]);
    }
  });

  function updateSubscriptionPriceFromSelect(selectEl) {
    if (!selectEl) return;
    var selectedOption = selectEl.options[selectEl.selectedIndex];
    if (!selectedOption) return;
    var price = selectedOption.getAttribute('data-allocation-price');
    if (!price) return;
    var group = selectEl.closest('.product__subs__group');
    if (!group) return;
    var priceEl = group.querySelector('.product__subs__price:not(.one-time-purchase)');
    if (!priceEl) return;
    priceEl.innerHTML = price;
    
    // Update economy badge
    updateEconomyBadge(selectEl);
  }

  function updateEconomyBadge(selectEl) {
    if (!selectEl) return;
    var selectedOption = selectEl.options[selectEl.selectedIndex];
    if (!selectedOption) return;
    var allocationValue = selectedOption.getAttribute('data-allocation-value');
    if (!allocationValue) return;
    
    var group = selectEl.closest('.product__subs__group');
    if (!group) return;
    var badge = group.querySelector('[data-economy-badge]');
    var percentageSpan = group.querySelector('[data-economy-percentage]');
    
    if (!badge || !percentageSpan) return;
    
    // Parse the allocation value (could be percentage or fixed amount)
    var isPercentage = allocationValue.includes('%');
    var value = parseFloat(allocationValue.replace(/[^\d.-]/g, ''));
    
    if (isPercentage && value > 0) {
      percentageSpan.textContent = value + '%';
      badge.style.display = 'inline-block';
    } else {
      badge.style.display = 'none';
    }
  }

  function formatMoneySafe(cents) {
    try {
      if (window.themeCurrency && window.theme && window.theme.moneyFormat) {
        var formatted = window.themeCurrency.formatMoney(cents, window.theme.moneyFormat);
        if (window.theme.settings && window.theme.settings.currency_code_enable && window.theme.currencyCode) {
          return formatted + ' ' + window.theme.currencyCode;
        }
        return formatted;
      }
    } catch (e) {}
    var amount = (Number(cents || 0) / 100).toFixed(2);
    return '$' + amount;
  }

  function rebuildSubscriptionPlanSelectsForVariant(variant) {
    if (!variant || !variant.selling_plan_allocations) return;
    var groups = document.querySelectorAll('.product__subs__group[data-selling-plan-group]');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var groupId = group.getAttribute('data-selling-plan-group');
      var select = group.querySelector('.product__subs__plans select[name="selling_plan"]');
      if (!select) continue;

      var allocations = variant.selling_plan_allocations.filter(function(a) {
        return String(a.selling_plan_group_id) === String(groupId);
      });

      // Map allocations by selling plan id for quick lookup
      var allocById = {};
      for (var j = 0; j < allocations.length; j++) {
        allocById[String(allocations[j].selling_plan_id)] = allocations[j];
      }

      // Preserve previously selected selling plan id if still available
      var previousSelectedId = select.value;
      var firstAvailableId = null;

      // Update existing options only: preserve their text content
      for (var k = 0; k < select.options.length; k++) {
        var option = select.options[k];
        var id = String(option.value);
        var alloc = allocById[id];
        if (alloc) {
          option.disabled = false;
          option.setAttribute('data-allocation-price', formatMoneySafe(alloc.price));
          if (!firstAvailableId) firstAvailableId = id;
        } else {
          // Option not available for this variant
          option.disabled = true;
          option.removeAttribute('data-allocation-price');
        }
      }

      // Adjust selection if previous is no longer available
      var prevOption = previousSelectedId ? select.querySelector('option[value="' + previousSelectedId + '"]') : null;
      var canKeepPrev = prevOption && !prevOption.disabled;
      if (!canKeepPrev) {
        if (firstAvailableId) {
          select.value = firstAvailableId;
        }
      }

      // Enable/disable the select depending on whether its radio group is active
      var radio = group.querySelector('[data-toggles-group]');
      if (radio && radio.checked) {
        select.disabled = false;
      } else {
        select.disabled = true;
      }

      // Reflect price in UI for this group's current selection
      updateSubscriptionPriceFromSelect(select);
    }
  }

  var CART_TOOLTIP_TRIGGERS = '.shipping-progress-bar--has-tooltip, .reassurance-block--has-tooltip';
  var CART_TOOLTIP_ICON_TRIGGERS = '.shipping-progress-bar__message-tooltip-icon, .reassurance-block__tooltip';
  var CART_TOOLTIP_OPEN_CLASS = 'is-open';
  var CART_TOOLTIP_CONTENT = '.shipping-progress-bar__message-tooltip-text, .reassurance-block__tooltip-text';
  var lastCartTooltipTouched = { trigger: null, time: 0 };
  var MOBILE_CLICK_SUPPRESS_MS = 400;
  var TOOLTIP_CLOSE_DELAY_MS = 100;
  var cartTooltipCloseTimers = new WeakMap();

  function closeAllCartDrawerTooltips() {
    document.querySelectorAll(CART_TOOLTIP_TRIGGERS).forEach(function(el) {
      clearTimeout(cartTooltipCloseTimers.get(el));
      el.classList.remove(CART_TOOLTIP_OPEN_CLASS);
    });
    lastCartTooltipTouched.trigger = null;
  }

  function scheduleTooltipClose(trigger) {
    clearTimeout(cartTooltipCloseTimers.get(trigger));
    cartTooltipCloseTimers.set(trigger, setTimeout(function() {
      trigger.classList.remove(CART_TOOLTIP_OPEN_CLASS);
    }, TOOLTIP_CLOSE_DELAY_MS));
  }

  function cancelTooltipClose(trigger) {
    clearTimeout(cartTooltipCloseTimers.get(trigger));
  }

  function isInsideCartDrawer(node) {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    return drawer && drawer.contains(node);
  }

  function isHoverCapablePointer() {
    if (!window.matchMedia) return false;
    try {
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener('click', function(e) {
    var target = e.target;
    var insideTooltipContent = target.closest(CART_TOOLTIP_CONTENT);
    if (insideTooltipContent) return;

    var trigger = target.closest(CART_TOOLTIP_TRIGGERS);

    // On non-hover devices (touch), allow click to toggle as a fallback
    if (!isHoverCapablePointer() && trigger && trigger.contains(target)) {
      if (lastCartTooltipTouched.trigger === trigger && (Date.now() - lastCartTooltipTouched.time) < MOBILE_CLICK_SUPPRESS_MS) {
        lastCartTooltipTouched.trigger = null;
        return;
      }
      trigger.classList.toggle(CART_TOOLTIP_OPEN_CLASS);
      return;
    }

    // Click outside any trigger closes all tooltips on all devices
    if (!trigger) {
      closeAllCartDrawerTooltips();
    }
  }, true);

  // Desktop: open/close on hover — only when entering/leaving the icon element
  document.addEventListener('mouseover', function(e) {
    if (!isHoverCapablePointer()) return;
    var target = e.target;
    var iconEl = target.closest(CART_TOOLTIP_ICON_TRIGGERS);
    if (!iconEl) return;

    var related = e.relatedTarget;
    if (related && iconEl.contains(related)) return;

    var trigger = target.closest(CART_TOOLTIP_TRIGGERS);
    if (!trigger) return;

    cancelTooltipClose(trigger);
    closeAllCartDrawerTooltips();
    trigger.classList.add(CART_TOOLTIP_OPEN_CLASS);
  }, true);

  document.addEventListener('mouseout', function(e) {
    if (!isHoverCapablePointer()) return;
    var target = e.target;
    var iconEl = target.closest(CART_TOOLTIP_ICON_TRIGGERS);
    if (!iconEl) return;

    var related = e.relatedTarget;
    if (related && iconEl.contains(related)) return;

    var trigger = target.closest(CART_TOOLTIP_TRIGGERS);
    if (!trigger) return;

    scheduleTooltipClose(trigger);
  }, true);

  document.addEventListener('touchend', function(e) {
    var target = e.target;
    var trigger = target.closest(CART_TOOLTIP_TRIGGERS);
    if (!trigger || !trigger.contains(target)) return;
    trigger.classList.toggle(CART_TOOLTIP_OPEN_CLASS);
    lastCartTooltipTouched.trigger = trigger;
    lastCartTooltipTouched.time = Date.now();
  }, true);

  document.addEventListener('touchmove', function(e) {
    if (!isInsideCartDrawer(e.target)) return;
    closeAllCartDrawerTooltips();
  }, { passive: true });
})();

/*
 * New search bar (formerly the Intelligems test variant, now the only version).
 * Adds: a panel before typing (recent / popular / best sellers), a results
 * panel rendered by sections/predictive-search-nsb.liquid, a product count
 * from templates/search.nsb-count.liquid, and placeholder swaps.
 */
(function () {
  var STORAGE_KEY = 'nsb_recent_searches';
  var RECENT_MAX = 5;
  var RECENT_SHOW = 3;
  var MOBILE_QUERY = '(max-width: 1252px)';
  var SECTION_ID = 'predictive-search-nsb';
  var CLOCK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M12 7.5V12l3 2"/></svg>';

  if (!window.customElements) return;
  var PredictiveSearch = customElements.get('predictive-search');
  if (!PredictiveSearch) return;

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function searchUrl(ps) {
    var action = ps.input && ps.input.form ? ps.input.form.getAttribute('action') : null;
    return action || '/search';
  }

  /* ---------- results: fetch the new section + a product count ---------- */
  PredictiveSearch.prototype.getSearchResults = function (searchTerm) {
    return nsbGetSearchResults.call(this, searchTerm);
  };

  function applyCount(sectionEl, count) {
    var root = sectionEl.querySelector('[data-nsb-results]');
    if (!root || count === null) return;
    var label = count === 1 ? root.getAttribute('data-nsb-one') : root.getAttribute('data-nsb-other');
    root.querySelectorAll('[data-nsb-count]').forEach(function (el) { el.textContent = count; });
    root.querySelectorAll('[data-nsb-count-label]').forEach(function (el) { el.textContent = label; });
    root.querySelectorAll('[data-nsb-count-wrap]').forEach(function (el) { el.hidden = false; });
    var seeCount = root.querySelector('[data-nsb-see-count]');
    var seeAll = root.querySelector('[data-nsb-see-all-text]');
    if (seeCount && count > 0) {
      seeCount.textContent = (seeCount.getAttribute('data-template') || '').replace('__N__', count);
      seeCount.hidden = false;
      if (seeAll) seeAll.hidden = true;
    }
  }

  function nsbGetSearchResults(searchTerm) {
    var self = this;
    var term = String(searchTerm || '').trim();
    var key = term.toLowerCase();
    this.nsbCache = this.nsbCache || {};
    this.setLiveRegionLoadingState();

    if (this.nsbCache[key]) {
      this.renderSearchResults(this.nsbCache[key]);
      return;
    }

    if (this.loader) this.loader.style.display = 'block';
    var signal = this.abortController ? this.abortController.signal : undefined;
    var suggestBase = (window.theme && theme.routes && theme.routes.predictive_search_url) || '/search/suggest';
    var suggestUrl = suggestBase + '?q=' + encodeURIComponent(term) +
      '&resources[type]=product,query&resources[limit]=6&resources[limit_scope]=each&section_id=' + SECTION_ID;
    var countUrl = searchUrl(this) + '?q=' + encodeURIComponent(term) + '&type=product&view=nsb-count';

    Promise.all([
      fetch(suggestUrl, { signal: signal }).then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed: ' + response.status);
        return response.text();
      }),
      fetch(countUrl, { signal: signal }).then(function (response) {
        return response.ok ? response.text() : '';
      }).catch(function () { return ''; })
    ]).then(function (results) {
      var doc = new DOMParser().parseFromString(results[0], 'text/html');
      var section = doc.querySelector('#shopify-section-' + SECTION_ID);
      if (!section || !section.querySelector('[data-predictive-search-live-region-count-value]')) return;
      var count = parseInt(String(results[1]).trim(), 10);
      applyCount(section, isNaN(count) ? null : count);
      var markup = section.innerHTML;
      self.nsbCache[key] = markup;
      self.renderSearchResults(markup);
    }).catch(function (error) {
      if (!error || error.name !== 'AbortError') console.error(error);
    }).finally(function () {
      if (self.loader) self.loader.style.display = 'none';
    });
  }

  /* The inline desktop field is a dropdown, not an overlay: never lock page scroll for it. */
  var originalEvaluateScrollLock = PredictiveSearch.prototype.evaluateScrollLock;
  PredictiveSearch.prototype.evaluateScrollLock = function () {
    if (this.closest('.nsb-inline')) {
      this.unlockScroll();
      return;
    }
    return originalEvaluateScrollLock.call(this);
  };

  /* ---------- recent searches ---------- */
  function getRecent() {
    try {
      var list = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (t) { return typeof t === 'string' && t.trim(); }) : [];
    } catch (e) {
      return [];
    }
  }

  function saveRecent(term) {
    term = String(term || '').trim();
    if (!term) return;
    var list = getRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, RECENT_MAX)));
    } catch (e) { /* storage unavailable: recent searches simply stay empty */ }
  }

  function renderRecent(ps) {
    var wrap = ps.querySelector('[data-nsb-recent-wrap]');
    var list = ps.querySelector('[data-nsb-recent]');
    if (!wrap || !list) return;
    var items = getRecent().slice(0, RECENT_SHOW);
    var base = searchUrl(ps);
    wrap.hidden = items.length === 0;
    list.innerHTML = items.map(function (term) {
      return '<li class="nsb-row"><a class="nsb-row__link" href="' + base + '?q=' + encodeURIComponent(term) +
        '" data-nsb-term="' + escapeHtml(term) + '">' + CLOCK_SVG + '<span>' + escapeHtml(term) + '</span></a></li>';
    }).join('');
  }

  /* ---------- idle panel (focused, nothing typed yet) ---------- */
  function openIdle(ps) {
    renderRecent(ps);
    ps.classList.add('nsb-idle-open');
  }

  function closeIdle(ps) {
    ps.classList.remove('nsb-idle-open');
  }

  function closeAll(ps) {
    closeIdle(ps);
    if (ps.hasAttribute('open') && typeof ps.close === 'function') ps.close();
    // Magnifier + popdown mode (laptops): dismiss the bar too, through the theme's own close button.
    var popdown = ps.closest('#search-popdown');
    if (popdown && popdown.classList.contains('is-visible')) {
      var closeButton = popdown.querySelector('[data-close-popdown]');
      if (closeButton) closeButton.click();
    }
  }

  function setup(ps) {
    if (ps.nsbReady || !ps.input) return;
    ps.nsbReady = true;
    var input = ps.input;

    input.addEventListener('focus', function () {
      if (!input.value.trim()) openIdle(ps);
    });

    input.addEventListener('input', function () {
      if (input.value.trim()) closeIdle(ps); else openIdle(ps);
    });

    if (input.form) {
      input.form.addEventListener('submit', function () {
        saveRecent(input.value);
      });
    }

    ps.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-nsb-term], a[data-nsb-product]');
      if (!link) return;
      saveRecent(link.getAttribute('data-nsb-term') || input.value);
    });

    ps.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      closeAll(ps);
      input.blur();
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-popdown-toggle="search-popdown"]')) return;
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      if (ps.contains(event.target)) return;
      closeAll(ps);
    });
  });

  /* ---------- placeholders ---------- */
  var mobileQuery = window.matchMedia(MOBILE_QUERY);

  function applyPlaceholders() {
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      var input = ps.input;
      if (!input) return;
      var next = mobileQuery.matches ? input.dataset.nsbPlaceholderMobile : input.dataset.nsbPlaceholder;
      if (next) input.placeholder = next;
    });
  }

  /* ---------- wiring ---------- */
  function sync() {
    document.querySelectorAll('predictive-search').forEach(setup);
    applyPlaceholders();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', applyPlaceholders);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(applyPlaceholders);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
